export const version = '0.757.0'
export const chameleonWebVersion = '8.9.1'
export const chameleonCoreVersion = '7.6.0'
